import { render, staticRenderFns } from "./ExpertFeesProjectList.vue?vue&type=template&id=1d99beb9"
import script from "./ExpertFeesProjectList.vue?vue&type=script&lang=js"
export * from "./ExpertFeesProjectList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports